import { __assign } from "tslib";
import { css } from 'emotion';
import { Form as FormikForm, Formik } from 'formik';
import _ from 'lodash';
import React from 'react';
import { Button, Col, Row } from 'reactstrap';
export var Form = function (props) {
    var renderButtons = function (_a) {
        var isSubmitting = _a.isSubmitting;
        return (React.createElement(Row, { mt: props.showButtonsOnTop ? 0 : 2, mb: props.showButtonsOnTop ? 2 : 0, className: "d-flex justify-content-between flex-row-reverse" },
            React.createElement(Button, { className: css({
                    display: props.showSubmitButton ? 'unset' : 'none',
                }), color: "primary", type: "submit", disabled: isSubmitting }, props.submitText),
            React.createElement(Button, { className: css({
                    display: props.showCancelButton ? 'unset' : 'none',
                }), color: "secondary", disabled: isSubmitting, onClick: props.onCancel }, props.cancelText)));
    };
    var renderChildren = function (childrenProps) {
        if (props.children) {
            if (_.isFunction(props.children)) {
                return props.children(childrenProps);
            }
            else {
                return props.children;
            }
        }
        else {
            return (React.createElement("div", null,
                React.createElement("p", { className: "text-danger" }, "There aren't any children in the form.")));
        }
    };
    return (React.createElement(Formik, __assign({}, props), function (childrenProps) {
        var isSubmitting = childrenProps.isSubmitting;
        return (React.createElement(FormikForm, null,
            props.showButtonsOnTop && React.createElement(Col, { mb: 2 }, renderButtons({ isSubmitting: isSubmitting })),
            renderChildren(childrenProps),
            !props.showButtonsOnTop && React.createElement(Col, { mt: 2 }, renderButtons({ isSubmitting: isSubmitting }))));
    }));
};
Form.defaultProps = {
    submitText: 'Submit',
    cancelText: 'Cancel',
    showButtonsOnTop: false,
    showCancelButton: true,
    showSubmitButton: true,
    onCancel: function () { }
};
//# sourceMappingURL=Form.js.map